import { homePageBreadcrumbs } from 'utils/breadcrumbs';
import { EntryType } from '../../types/api';

export const subHeaderTitle: Record<EntryType, string> = {
  [EntryType.requests]: 'Заявки',
  [EntryType.registry]: 'Реестр',
  [EntryType.inactive]: 'Регистрация аннулирована',
};

export const getBreadcrumbs = (registryName: string, subRegistryName?: string) => {
  const breadcrumbs = [
    homePageBreadcrumbs,
    {
      text: registryName,
    },
  ];

  if (subRegistryName) {
    breadcrumbs.push({
      text: subRegistryName,
    });
  }
  return breadcrumbs;
};
